export class DataCatalogPolicyScope {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "descendantsTagExpression",
            "baseName": "descendantsTagExpression",
            "type": "DataCatalogTagExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPolicyScope.attributeTypeMap;
    }
    constructor() {
    }
}
